import HomeTemplate from "../components/templates/HomeTemplate"
import { HOME_SECTIONS } from "../utils/constants/sections";

const HomePage = (props) => {
    return (
        <HomeTemplate sections={HOME_SECTIONS} />
    );
}

export default HomePage;